import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../../app/guards'
import { MyTimePage } from '../../../../features/projects/time/my-time-page'
import { myTimeSearchSchema } from '../../../../features/projects/time/search'

/** My time (projects/06 §5.9): the person's own week of time on projects. */
export const Route = createFileRoute('/_app/projects/time/')({
  staticData: { crumb: 'projectTime' },
  validateSearch: myTimeSearchSchema,
  beforeLoad: ({ context }) => requirePermission(context.session, 'projects.time'),
  component: MyTimePage,
})
